import { Modal } from "@mantine/core";
import type { FieldNameToLabelMap } from "../../../../HistoryTab/HistoryTab";
import { HistoryTab } from "../../../../HistoryTab/HistoryTab";

const fieldNameToLabelMap: FieldNameToLabelMap = {
  state: "Status",
  calculated_amount: "Zu prüfender Wert",
  user_provided_amount: "Prüfwert",
  label: "Bezeichnung",
  notes: "Notizen",
  timestamp_of_state_change: "Letzter Statuswechsel"
};

interface VerificationHistoryModalProps {
  verificationItemId?: string;
  onClose: () => void;
}

function VerificationHistoryModal({
  verificationItemId,
  onClose
}: VerificationHistoryModalProps) {
  return (
    <Modal
      opened={!!verificationItemId}
      size="lg"
      title="Historie zum Prüfeintrag"
      onClose={onClose}
    >
      {verificationItemId && (
        <HistoryTab
          entityId={verificationItemId}
          entityType="revenueMonitoringCellCheck"
          fieldNameToLabelMap={fieldNameToLabelMap}
        />
      )}
    </Modal>
  );
}

export { VerificationHistoryModal, VerificationHistoryModalProps };
